import { isAfter, isBefore, isWeekend, set } from 'date-fns';
import { utcToZonedTime } from 'date-fns-tz';

export const createZendeskWidget = (disabled: boolean, apiKey: string) => {
  if (disabled) {
    return;
  }

  const now = utcToZonedTime(new Date(), 'US/Central');
  const start = set(now, { hours: 8, minutes: 0, seconds: 0 });
  const end = set(now, { hours: 17, minutes: 0, seconds: 0 });

  if (isWeekend(now) || isBefore(now, start) || isAfter(now, end)) {
    return;
  }

  const zendeskWidgetScript = document.createElement('script');
  zendeskWidgetScript.src = `https://static.zdassets.com/ekr/snippet.js?key=${apiKey}`;
  zendeskWidgetScript.id = 'ze-snippet';
  document.body.appendChild(zendeskWidgetScript);
};
